import { appEnvironment, isFogo } from './appEnvironment';

export const SOL_MINT = 'So11111111111111111111111111111111111111112';
export const FOGO_MINT = 'FoGo111111111111111111111111111111111111112';
export const FLUXB_MINT = 'FLUXBmPhT3Fd1EDVFdg46YREqHBeNypn1h4EbnTzWERX';

// Fogo CDN only serves image.png — image.webp returns 404 there.
// Native FOGO uses SOL_MINT on the Fogo CDN; FOGO_MINT has no metadata/image there.
const getImageExtension = (): string => (isFogo() ? 'png' : 'webp');

export const getMintImageURL = (mint: string): string =>
	`${appEnvironment.urls.cdn}/v1/tokens/${mint}/image.${getImageExtension()}`;
